module.exports = __webpack_public_path__ + "img/nathalie_cabinet_saint-cyr-lecole.3e875d72.webp";